import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import LabelText from '../LabelText';
import TextareaAutosize from 'react-textarea-autosize';
import { getUserFieldValue } from '../../../Util/Util';

const Text = (props) => {
	const { t, i18n } = useTranslation();

	const {form_component} = props;
	const {fieldname, default_text_type, default_text, input_type, required} = form_component;

	const fv = useSelector(state => state.fv);
	const userData = useSelector(state => state.userData);
	let userFieldValue = getUserFieldValue(fieldname, userData);
	useEffect(() => { // to be updated after render
		if (fv && form_component.required) {
			var validator = {
				validators: {
					notEmpty: {
						message: t('此欄為必須填寫')
					}
				}
			};

			if (form_component.input_type === 'number') {
				validator.validators.Integer = {
					message: t('只可輸入數字')
				};
			};

			fv.addField(form_component.fieldname, validator);
		}
	}, [fv]);

	const inputProps = {
	    name: form_component.fieldname,
	    placeholder: form_component.default_text_type === 'placeholder' ? form_component.default_text : '',
	    className: "form-control-sm mb-3 form-control",
	    id: form_component.fieldname,
	    defaultValue: userFieldValue || ''
	};

	return (
		<div className={`flex-grow-1 form-group text ${required ? 'required' : ''}`}>
			<LabelText
				form_component={form_component}
			/>
			{input_type === 'textarea' ? (
				<TextareaAutosize {...inputProps} minRows={3} />
			) : (
				<input
					type={input_type === 'number' ? 'text' : input_type}
					{...inputProps} 
				/>
			)}
		</div>
	);
}

export default Text;